import { Component, Input } from '@angular/core';


export class SkyKeyInfoComponent {
  
  public layout = 'vertical';
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-key-info',
  template: `<div
    class="sky-key-info"
    [ngClass]="{
      'sky-key-info-horizontal': layout === 'horizontal'
    }"
>
  <div class="sky-key-info-value">
    <ng-content select="sky-key-info-value"></ng-content>
  </div>
  <div class="sky-key-info-label">
    <ng-content select="sky-key-info-label"></ng-content>
  </div>
</div>
`,
  styles: [`.sky-key-info {
  display: inline-block;
  margin-right: 30px;
}

.sky-key-info-value {
  font-family: "Blackbaud Sans Condensed", "Helvetica Neue Condensed", "Arial Narrow";
  color: #282b31;
  font-weight: 500;
  font-size: 22px;
}

.sky-key-info-label {
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #686c73;
  font-weight: 400;
  font-size: 15px;
}

.sky-key-info-horizontal .sky-key-info-value,
.sky-key-info-horizontal .sky-key-info-label {
  display: inline-block;
}

.sky-key-info-horizontal .sky-key-info-label {
  margin-left: 5px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'layout': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
